import { configActions } from 'core/Config';
import { parseBool } from 'shared/utils';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    FormGroup,
    Input,
    Table
} from 'mol-ui';
import React, { useEffect, useMemo } from 'react';
import {
    useArray,
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const ServicesConfiguration = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { dangerColor, successColor } = useTheme();
    const [currentConfiguration, setCurrentConfiguration, {
        replaceValues
    }] = useArray([], { type: 'object' });
    const [filterInput, filter] = useInput('');

    const {
        platformConfigurationLoading,
        platformConfigurationProcessing,
        servicesConfiguration
    } = useSelector('config');

    useEffect(() => {
        dispatch(configActions.getServicesConfiguration());
    }, []);

    useEffect(() => {
        setCurrentConfiguration(servicesConfiguration);
    }, [servicesConfiguration, setCurrentConfiguration]);

    const handleChange = (id, value) => {
        replaceValues({ enabled: value ? 1 : 0 }, 'id', id);
    };

    const actionController = [{
        display: ({ enabled }) => !enabled,
        icon: 'done',
        onClick: ({ id }) => handleChange(id, true),
        title: t('Activar')
    }, {
        display: ({ enabled }) => !!enabled,
        icon: 'close',
        onClick: ({ id }) => handleChange(id, false),
        title: t('Desactivar')
    }];

    const onSubmit = () => {
        dispatch(configActions.updateServicesConfiguration({
            services: currentConfiguration.map(s => ({
                enabled: s?.enabled,
                id: s?.id
            }))
        }));
    };

    const headers = [{
        flex: 3,
        key: 'label',
        label: t('Nombre')
    }, {
        accessor: enabled => parseBool(!!enabled),
        format: ({ enabled }) => ({
            center: true,
            color: !!enabled ? successColor : dangerColor
        }),
        key: 'enabled',
        label: t('Activado')
    }];

    const filteredConfiguration = useMemo(
        () => currentConfiguration.filter(({ label }) => !filter || label.toLowerCase().includes(filter.toLowerCase())),
        [currentConfiguration, filter]
    );

    return (
        <Container>
            <Container margin="0px 10px">
                <FormGroup label={ t('Buscar configuración') } margin="10px 0px 0px 0px" width="100%">
                    <Input { ...filterInput } />
                </FormGroup>
            </Container>
            <Table
                config={ headers }
                data={ filteredConfiguration }
                loading={ platformConfigurationLoading }
                rowActions={ actionController }
            />
            <ButtonFooter>
                <ExpandButton
                    caption={ t('Guardar') }
                    loading={ platformConfigurationProcessing }
                    size={ 100 }
                    width={ 100 }
                    onClick={ onSubmit }
                />
            </ButtonFooter>
        </Container>
    );
};

export default ServicesConfiguration;
